<template>
  <div class="checkout-builder-backgroud-image px-6">
    <bp-input-file
      is-image
      class="w-100"
      v-model="image"
      @input="saveBackground"
    />
  </div>
</template>

<script>
export default {
  computed: {
    image: {
      get() {
        return this.$store.state.checkoutBuilder?.background?.image;
      },
      set(v) {
        this.$store.commit("checkoutBuilder/setBackground", {
          image: v,
          color: ""
        });
      }
    }
  },
  methods: {
    saveBackground() {
      this.$store.dispatch("checkoutBuilder/saveSnapshot");
    }
  }
};
</script>

<style lang="scss" scoped></style>
